/**
 * Alpine component behind a labelled "Copy link" button. The value is fixed when
 * the page renders, and the copying itself is the same as the icon-only copyButton.
 */
import { copyButtonData } from "./copy_button.js";

export function clipboardCopyData(url, options) {
  const { copy, ...state } = copyButtonData(options);

  return {
    ...state,
    copy() {
      copy.call(this, url);
    }
  };
}

export default function registerClipboardCopy(Alpine) {
  Alpine.data("clipboardCopy", (url) => clipboardCopyData(url));
}
